import { Chapter, FadeUp } from "@/components/Reveal";

const SOLUTIONS = [
  {
    img: "/report-2.png",
    title: "Le Mémo Flash (Triage)",
    text: "Évaluation de l'urgence, fixation de la date de cessation des paiements et alerte sur la trésorerie.",
  },
  {
    img: "/loupe.png",
    title: "Audit d'Investigation",
    text: "Mise en lumière des choix stratégiques et des décisions de gestion ayant impacté la santé financière. Une analyse rigoureuse ancrée dans la réalité économique de l'entreprise, de son marché et de son territoire.",
  },
  {
    img: "/path-forward.png",
    title: "Plan de Restructuration",
    text: "Modélisations financières crash-testées, scénarios de viabilité et capacité de remboursement.",
  },
  {
    img: "/modelisation-multi.png",
    title: "Évaluations Multicritères",
    text: "Modélisations financières (DCF) et comparatives.",
    soon: true,
  },
  {
    img: "/flux.png",
    title: "Analyses de Transmission",
    text: "Modélisation pour des processus de cession et valorisation d'actifs.",
    soon: true,
  },
  {
    img: "/data-room.png",
    title: "Data Room Souveraine",
    text: "Espace chiffré de bout-en-bout pour centraliser vos pièces (FEC, liasses), échanger en toute confidentialité et piloter nos analyses.",
    soon: true,
  },
];

export default function Solutions() {
  return (
    <section id="solutions" className="bg-slate-50" data-testid="solutions-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 py-24 sm:py-28 lg:py-32">
        <FadeUp>
          <Chapter index="04" label="Solutions" />
        </FadeUp>
        <FadeUp delay={0.1}>
          <h2 className="mt-8 max-w-3xl font-sans font-extrabold text-slate-900 text-3xl sm:text-4xl leading-[1.15] tracking-tight">
            Des solutions d'analyse taillées pour les enjeux complexes.
          </h2>
        </FadeUp>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SOLUTIONS.map((s, i) => (
            <FadeUp key={s.title} delay={0.08 * i}>
              <article
                data-testid={`solution-card-${i}`}
                className="group bg-white border border-gray-200 rounded-2xl overflow-hidden h-full shadow-md hover:border-slate-400 hover:shadow-xl transition-all duration-500 cursor-pointer"
              >
                <div className="overflow-hidden">
                  <img
                    src={s.img}
                    alt={s.title}
                    className="h-40 w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                </div>
                <div className="p-7">
                  <div className="flex items-center justify-between">
                    <span className="font-mono text-xs text-slate-400">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {s.soon && (
                      <span
                        data-testid={`solution-card-${i}-badge`}
                        className="bg-black text-white font-extrabold text-xs uppercase px-4 py-1 rounded-full shadow-md border border-slate-700"
                      >
                        Prochainement
                      </span>
                    )}
                  </div>
                  <h3 className="mt-3 font-sans text-xl font-bold text-slate-900 tracking-tight">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm text-gray-600 leading-relaxed">{s.text}</p>
                </div>
              </article>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
